<div class="w-full flex justify-center">
  <div *ngIf="!isLogged" class="inline-flex bg-gray-8">
    <div class="w-screen px-[59.5px] pt-[32px] text-gray-1">
      <div class="flex justify-between mx-auto w-[1240px]">
        <div>
          <img src="./assets/svg/tagline.svg" class="w-[142px] h-[50px]" alt="Logo de AVLA" />
          <div class="icons flex flex-row items-center justify-between max-w-[144px] my-5">
            <a href="{{ environment.twitterURL }}" target="_blank"><img src="./assets/svg/twitter-icon.svg"
                alt="Logo de Twitter" /></a>
            <a href="{{ environment.facebookURL }}" target="_blank"><img src="./assets/svg/facebook-icon.svg"
                alt="Logo de Facebook" /></a>
            <a href="{{ environment.linkedinURL }}" target="_blank"><img src="./assets/svg/linkedin-icon.svg"
                alt="Logo de Linkedin" /></a>
            <a href="{{ environment.instagramURL }}" target="_blank"><img src="./assets/svg/instagram-icon.svg"
                alt="Logo de Instagram" /></a>
            <a href="{{ environment.youtubeURL }}" target="_blank"><img src="./assets/svg/youtube-icon.svg"
                alt="Logo de Youtube" /></a>
          </div>
          <p class="text-m">
            Cerro El Plomo 5420, Piso 10, <br />
            Las Condes, Región Metropolitana
          </p>
        </div>
        <div>
          <h4 class="text-xl mb-4">Cotiza 100% online</h4>
          <a href="{{ environment.ventaEnVerdeURL }}" target="_blank" class="block text-m underline">Venta en verde</a>
          <a href="{{ environment.seguroDeGarantiaURL }}" target="_blank" class="block text-m my-4 underline">Seguro de garantía</a>
          <a href="{{ environment.seguroDeCreditoURL }}" target="_blank" class="text-m underline">Seguro de crédito</a>
        </div>
        <div>
          <h4 class="text-xl mb-4">Nosotros</h4>
          <a href="{{ environment.agilidadAvlaURL }}" target="_blank" class="block text-m underline">Agilidad AVLA</a>
          <a href="{{ environment.misionAvlaURL }}" target="_blank" class="block text-m my-4 underline">Misión AVLA</a>
          <a href="{{ environment.impactoEsgURL }}" target="_blank" class="text-m underline">Impacto ESG</a>
        </div>
        <div>
          <h3 class="text-2xl font-medium">¿Tienes dudas? ¡Contáctanos!</h3>
          <div class="flex gap-16">
            <p class="text-m font-light mt-8">
              A través del correo <br />
              <a href="mailto:contacto@avla.com" class="text-m font-medium">contacto@avla.com</a>
            </p>
            <p class="text-m font-light mt-8">
              O por teléfono: <br />
              <a class="text-m font-medium" href="tel:+56-2-2706-8900">+56 2 2706 8900</a>
            </p>
          </div>
        </div>
      </div>
      <div class="flex justify-center border-t-2 border-light-blue my-4 w-[1240px] mx-auto">
        <div class="text-m flex justify-between w-[880px] py-2">
          <p>{{ year }} AVLA</p>
          <p (click)="onHandleOpenTermsYCond()" class="cursor-pointer">
            Términos y condiciones
          </p>
          <p (click)="onHandleOpenPolPriv()" class="cursor-pointer">
            Políticas de privacidad
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isLogged" class="w-full text-m my-4 flex justify-between">
    <p class="text-light-blue">{{ year }} AVLA</p>
    <p (click)="onHandleOpenTermsYCond()" class="cursor-pointer">
      Términos y condiciones
    </p>
    <p (click)="onHandleOpenPolPriv()" class="cursor-pointer">
      Políticas de privacidad
    </p>
  </div>
</div>
<app-modal-terms-conditions></app-modal-terms-conditions>
<app-modal-policy-privacy></app-modal-policy-privacy>